
<template>
  <div class="login">
    <h1>Melden Sie sich an</h1>
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>

    <b-alert v-model="isSucceded" v-if="isSucceded" variant="success">
      Vielen Dank {{form.userProfile.vorname}} {{form.userProfile.name}} für Ihre Registration.<br>
      Ihr Konto wurde erstellt und Sie können sich <router-link to="/" class="login-link">hier anmelden</router-link>
    </b-alert>

    <validation-observer v-slot="{ handleSubmit }" v-else>
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <validation-observer :key="1" v-if="formPage === 1" ref="observer">

          <validation-provider vid="email" rules="required|email" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-email" label="E-Mail *" label-for="input-email">
              <b-form-input
                id="input-email"
                v-model="form.email"
                :state="onValidateField(valid, errors, changed)"
                type="email"
                placeholder="E-Mail angeben"
              ></b-form-input>
              <span class="input-live-feedback">{{ errors[0] }}</span>
            </b-form-group>
          </validation-provider>

          <validation-provider vid="password" name="Password" rules="required|min:5" ref="password" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-password" label="Passwort *" label-for="input-password">
              <b-form-input
                id="input-password"
                v-model="form.password"
                :state="onValidateField(valid, errors, changed)"
                type="password"
                placeholder="Passwort angeben"
              ></b-form-input>
              <span class="input-live-feedback">{{ errors[0] }}</span>
            </b-form-group>
          </validation-provider>

          <validation-provider name="passwordConfirm" rules="required|confirmed:password" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-confirm-password" label="Passwort wiederholen *" label-for="input-confirm-password">
              <b-form-input
                id="input-password-confirm"
                v-model="form.passwordConfirm"
                :state="onValidateField(valid, errors, changed)"
                type="password"
                placeholder="Passwort wiederholen"
              ></b-form-input>
              <span class="input-live-feedback">{{ errors[0] }}</span>
            </b-form-group>
          </validation-provider>

          <validation-provider vid="identificationMobileNr" rules="required|swissPhoneNumber" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-identification-number" label="Mobiltelefon-Nr. für SMS-Bestätigungscode  *" label-for="input-identification-number">
              <b-form-input
                id="input-identification-number"
                v-model="form.identificationMobileNr"
                :state="onValidateField(valid, errors, changed)"
                placeholder="Format: +41 79 999 99 99"
              ></b-form-input>
              <small>Sie brauchen zum Einloggen einen Bestätigungscode per SMS auf dieses Mobiltelefon.<br>Hinweis: Ohne SMS-Login können Sie das Förderportal nicht benutzen.<br></small>
              <span class="input-live-feedback">{{ errors[0] }}</span>
            </b-form-group>
          </validation-provider>

          <b-form-group>
            <b-form-checkbox
              id="tech-contact"
              v-model="form.userProfile.technischerKontakt"
              vid="technischer-kontakt"
            >
              Technischer Kontakt
            </b-form-checkbox>
            <small>Sie sind technischer Kontakt, wenn Sie als Firma Gesuche im Auftrag von Dritten und für Kunden erfassen und werden bei Rückfragen als Kontaktperson vorgemerkt. Hinweis: Zuweisung auch später möglich.</small>
          </b-form-group>

          <validation-provider vid="imKanton" :rules="{ required: {allowFalse: false}}" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-imKanton" label-for="input-terms-imKanton">
              <b-form-checkbox
                id="input-terms-imKanton"
                v-model="form.userProfile.imKanton"
                :state="onValidateField(valid, errors, changed)"
                name="terms-place"
              >
                Meine zu beantragenden Gesuche befinden sich ausschliesslich im Kanton St.Gallen *
              </b-form-checkbox>
            </b-form-group>
          </validation-provider>

          <validation-provider vid="nutzungsbedingungen" :rules="{ required: {allowFalse: false}}" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-nutzungsbedingungen" label-for="input-nutzungsbedingungen">
              <b-form-checkbox
                id="input-nutzungsbedingungen"
                v-model="form.userProfile.nutzungsbedingungen"
                :state="onValidateField(valid, errors, changed)"
                name="terms"
              >
                Ich stimme den Nutzungsbedingungen und Datenschutz-Bestimmungen zu *
              </b-form-checkbox>
            </b-form-group>
          </validation-provider>
        </validation-observer>

        <validation-observer :key="2" v-else-if="formPage === 2" ref="observer">

          <validation-provider vid="anrede">
            <b-form-group id="input-group-anrede" label="Anrede" label-for="input-anrede">
              <b-form-select v-model="form.userProfile.anrede" :options="titles" id="input-anrede"></b-form-select>
            </b-form-group>
          </validation-provider>

          <b-form-group id="input-group-firma" label="Firma" label-for="input-firma">
            <b-form-input
              id="input-firma"
              v-model="form.userProfile.firma"
              type="text"
              placeholder="Firma angeben"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-zusatz" vid="zusatz" label="Zusatz" label-for="input-zusatz">
            <b-form-input
              id="input-zusatz"
              v-model="form.userProfile.zusatz"
              type="text"
              placeholder="Zusatz angeben"
            ></b-form-input>
          </b-form-group>

          <validation-provider vid="vorname" rules="required" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-vorname" label="Vorname *" label-for="input-vorname">
              <b-form-input
                id="input-first-name"
                v-model="form.userProfile.vorname"
                :state="onValidateField(valid, errors, changed)"
                type="text"
                placeholder="Vorname angeben"
              ></b-form-input>
              <span class="input-live-feedback">{{ errors[0] }}</span>
            </b-form-group>
          </validation-provider>

          <validation-provider rules="required" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-name" label="Nachname *" label-for="input-name">
              <b-form-input
                id="input-last-name"
                v-model="form.userProfile.name"
                :state="onValidateField(valid, errors, changed)"
                type="text"
                placeholder="Nachname angeben"
              ></b-form-input>
              <span class="input-live-feedback">{{ errors[0] }}</span>
            </b-form-group>
          </validation-provider>

          <b-row>
            <b-col cols="9">
              <validation-provider rules="required" v-slot="{ valid, errors, changed }">
                <b-form-group id="input-group-strasse" label="Strasse *" label-for="input-strasse">
                  <b-form-input
                    id="input-street"
                    v-model="form.userProfile.strasse"
                    :state="onValidateField(valid, errors, changed)"
                    type="text"
                    placeholder="Strasse angeben"
                  ></b-form-input>
                  <span class="input-live-feedback">{{ errors[0] }}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="col">
              <b-form-group id="input-group-haus-nr" label="Nr." label-for="input-haus-nr">
                <b-form-input
                  id="input-haus-nr"
                  v-model="form.userProfile.hausNr"
                  type="text"
                  placeholder="Nr."
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="4">
              <validation-provider rules="required|numeric" v-slot="{ valid, errors, changed }">
                <b-form-group id="input-group-plz" label="PLZ *" label-for="input-plz">
                  <b-form-input
                    id="input-plz"
                    v-model="form.userProfile.plz"
                    :state="onValidateField(valid, errors, changed)"
                    type="text"
                    placeholder="Postleitzahl"
                  ></b-form-input>
                  <span class="input-live-feedback">{{ errors[0] }}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="col">
              <validation-provider rules="required" v-slot="{ valid, errors, changed }">
                <b-form-group id="input-group-ort" label="Ort *" label-for="input-ort">
                  <b-form-input
                    id="input-ort"
                    v-model="form.userProfile.ort"
                    :state="onValidateField(valid, errors, changed)"
                    type="text"
                    placeholder="Ort angeben"
                  ></b-form-input>
                  <span class="input-live-feedback">{{ errors[0] }}</span>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <validation-provider vid="land">
            <b-form-group id="input-group-confirm-land" label="Land" label-for="input-confirm-land">
              <b-form-select v-model="form.userProfile.land" :options="countries"></b-form-select>
            </b-form-group>
          </validation-provider>

          <validation-provider rules="phoneNumber" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-telefon" label="Mobiltelefon *" label-for="input-telefon">
              <b-form-input
                id="input-telefon"
                v-model="form.userProfile.telefon"
                :state="onValidateField(valid, errors, changed)"
                type="text"
                placeholder="Geben Sie Ihren Mobiltelefonnr. ein"
              ></b-form-input>
              <span class="input-live-feedback">{{ errors[0] }}</span>
            </b-form-group>
          </validation-provider>
        </validation-observer>

        <b-form-checkbox
          id="extra-option"
          class="d-none"
          v-model="form.honeypot"
        >
          Extra Option
        </b-form-checkbox>

        <b-button type="submit" variant="primary" class="register-btn" :disabled="isSubmitting">
          {{formPage === 1 ? 'Weiter zu den Personenangaben' : 'Anmeldung abschliessen'}}
        </b-button>

      </b-form>
    </validation-observer>

    <p v-if="!isSucceded">
      <router-link to="/">Zurück zum Login</router-link>
    </p>
    <ul class="agb-links">
      <li>
        <a class="modallink" v-on:click="openModal('kontakt')" v-b-modal.modal-scrollable-nb>Kontakt</a>
      </li>
      <li>
        <a class="modallink" v-on:click="openModal('agb')" v-b-modal.modal-scrollable-nb>Nutzungsbedingungen</a>
      </li>
      <li>
        <a class="modallink" v-on:click="openModal('datenschutz')" v-b-modal.modal-scrollable-nb>Datenschutz</a>
      </li>
      <li>
        <a class="modallink" v-on:click="openModal('impressum')" v-b-modal.modal-scrollable-nb>Impressum</a>
      </li>
    </ul>
    <modal-agb :showContent="showContent" :modalTitle="modalTitle"/>
  </div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { errorHandler, validateField } from '@/helpers/formHelper.js'
  import ModalAgb from '@/components/login/Modal.vue'

  const getInitialData = () => ({
    form: {
      email: '',
      password: '',
      passwordConfirm: '',
      identificationMobileNr: '',
      honeypot: false,
      userProfile: {
        anrede: 'Herr',
        firma: '',
        zusatz: '',
        vorname: '',
        name: '',
        strasse: '',
        hausNr: '',
        plz: '',
        ort: '',
        land: '16',
        telefon: '',
        technischerKontakt: false,
        imKanton: false,
        nutzungsbedingungen: false
      }
    }
  })

  export default {
    components: {
      ValidationObserver,
      ValidationProvider,
      ModalAgb
    },
    data: () => ({
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      formPage: 1,
      showContent: '',
      modalTitle: '',
      isSubmitting: false,
      countries: [
        { value: 16, text: 'Schweiz' },
        { value: 17, text: 'Deutschland' },
        { value: 18, text: 'Österreich' },
        { value: 19, text: 'Lichtenstein' },
        { value: 21, text: 'Frankreich' },
        { value: 20, text: 'Italien' },
        { value: 92, text: 'Israel' },
        { value: 91, text: 'USA' },
        { value: 241, text: 'Grossbritanien' }
      ],
      titles: [
        { value: 'Herr', text: 'Herr' },
        { value: 'Frau', text: 'Frau' },
        { value: 'Herr & Frau', text: 'Herr & Frau' }
      ],
      ...getInitialData()
    }),
    methods: {
      onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        // Honeypot check
        if (this.form.honeypot) {
          this.hasError = true
          this.errorMessage = 'Registrierung konnte nicht abgeschlossen werden.'
          return
        }

        this.$store.dispatch('user/REGISTER', this.form).then(res => {
          const { errors } = res

          if (errors) {
            const hasFirstFormPageErrors = errors.find(error => error.extensions.formPage === 1)

            if (!hasFirstFormPageErrors && this.formPage === 1) {
              this.formPage = 2
            }
            this.isSubmitting = false
            return errorHandler(this, errors)
          }

          this.isSucceded = true
          this.isSubmitting = false
          this.reset()
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          this.isSubmitting = false
          console.error(err)
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      },
      openModal (modal) {
        if (modal === 'agb') {
          this.showContent = 'agb'
          this.modalTitle = 'Nutzungsbedingungen'
        } else if (modal === 'datenschutz') {
          this.showContent = 'datenschutz'
          this.modalTitle = 'Datenschutz-Bestimmungen'
        } else if (modal === 'kontakt') {
          this.showContent = 'kontakt'
          this.modalTitle = 'Kontakt'
        } else if (modal === 'impressum') {
          this.showContent = 'impressum'
          this.modalTitle = 'Impressum'
        } else {
          this.showContent = ''
          this.modalTitle = ''
        }
      }
    }
  }
</script>

<style lang="scss">
  .input-live-feedback{
    color: $magenta;
    font-size: $font-size-sm;
  }
  .login-link{
    color: #0c5460 !important;
  }
  .agb-links{
    @include list-unstyled;
    margin-top: 5rem;

    li{
      padding-right: 15px;
      padding-left: 15px;
      display: inline-block;

        .modallink{
        text-decoration: underline;
        }
    }
  }
  .register-btn{
    margin: 0 auto;
    display: inherit;
  }

  .custom-control-input:checked ~ .custom-control-label::before{
    background-color: $green;
  }
</style>
